import Login from './Login';

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login/components/index.js